module.exports = __webpack_public_path__ + "media/application/images/2018/2018-arrow-nav-2e9299b624e00dbc2c554b093572bbe0.svg";